<div *ngIf="watchlistSnapshot$ | async as watchlistSnapshot"
     class="container">
  <div class="row">
    <div *ngIf="watchlistSnapshot?.parentUuid"
         class="gr-12 watchlist__breadcrumb">
      <a class="secondary"
         [routerLink]="['/watchlistSnapshots', watchlistSnapshot?.parentUuid]">
        <i class="icon">
          <p1-lib-icons-icon-wrapper name="iconArrowLeft"></p1-lib-icons-icon-wrapper>
        </i>
        <span>{{(parentWatchlistSnapshot$ | async)?.name}}</span>
      </a>
    </div>
    <div class="gr-12 spacing-down--base watchlist__header">
      <div class="row">
        <div class="watchlist__header-headline gr-12 gr-8@m">
          <h1>{{watchlistSnapshot?.name}}</h1>
          <p *ngIf="watchlistSnapshot?.comment"
             class="watchlist__header-comment">{{ watchlistSnapshot?.comment }}</p>
          <p *ngIf="(userAuthenticated$ | async) !== true"
             i18n="watchlist snapshot unauthenticated hint // page: watchlistSnapshots/{uuid} @@watchlist-snapshot-detail-page.component_unauthenticated_hint">
            <a [routerLink]="['/auth/register']">
              Sign up now
            </a>
            and save this watchlist or create and share your own.
          </p>
        </div>
        <div class="watchlist__header-actions gr-12 gr-4@m">
          <button p1Button
                  *ngIf="(userAuthenticated$ | async)"
                  [disabled]="(myWatchlistsStoreModuleLoaded$ | async) !== true"
                  (click)="openCopyWatchlistDialog()">
            <i class="icon">
              <p1-lib-icons-icon-wrapper name="iconWatchlistAdd"></p1-lib-icons-icon-wrapper>
            </i>
            <span i18n="watchlist snapshot save button // page: watchlistSnapshots/{uuid} @@watchlist-snapshot-detail-page.component_save_button">
              Save watchlist
            </span>
          </button>
          <a p1Button
             *ngIf="(userAuthenticated$ | async) !== true"
             [routerLink]="['/auth/login']"
             [queryParams]="{ reason: 'unauthorized', from: currentUrl$ | async }">
            <i class="icon">
              <p1-lib-icons-icon-wrapper name="iconLock"></p1-lib-icons-icon-wrapper>
            </i>
            <span i18n="watchlist snapshot save button // page: watchlistSnapshots/{uuid} @@watchlist-snapshot-detail-page.component_save_button">
              Save watchlist
            </span>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="hasContent$ | async"
         class="gr-12 gr-10@s gr-9@m gr-8@l spacing-down--base">
      <p1-watchlists-list class="sublists"
                          [watchlists]="childWatchlistSnapshots$ | async"
                          [detailPageLinkPrefix]="'/watchlistSnapshots'"
                          [maxPreviewCount]="10">
      </p1-watchlists-list>
      <p1-watchlist-content-list [watchlist]="watchlistSnapshot"></p1-watchlist-content-list>
    </div>
  </div>

  <div *ngIf="(hasContent$ | async) !== true"
       class="watchlist-empty">
    <div class="row">
      <div class="gr-12 gr-6@l gr-centered">
        <p1-empty-watchlist-snapshot-teaser></p1-empty-watchlist-snapshot-teaser>
      </div>
    </div>
  </div>
</div>

<p1-lib-ui-elements-portal [show]="showCopyWatchlistDialog"
           [portalTarget]="portalOutletName.modalOverlay">
  <p1-copy-watchlist-dialog [show]="showCopyWatchlistDialog"
                            [watchlistSnapshot]="watchlistSnapshot$ | async"
                            [copyWatchlistInProgress]="copyWatchlistInProgress$ | async"
                            (closeCopyDialog)="closeCopyWatchlistDialog()"
                            (copyWatchlist)="copyWatchlist($event)">
  </p1-copy-watchlist-dialog>
</p1-lib-ui-elements-portal>

